import React from 'react'


export default function FormPage3(props) {
    const email = "support@kizabo.com"

    //count down timer for resend link
    //fetch to resend
    //reset the timer when resend is clicked. And change text to "File has been resent. Check your inbox and spam folder. Resend in (150) seconds..."
    const [timer, setTimer] = React.useState(120); // 150 seconds
    const [resendCtr, setResendCtr] = React.useState(0);

    React.useEffect(() => {
        let ctrTimer = 120; // 120 seconds
        const interval = setInterval(() => {
            if (ctrTimer > 0) {
                ctrTimer--;
                setTimer(ctrTimer)
            } else {
                clearInterval(interval);
            }
        }, 1000);

        return () => clearInterval(interval); // Cleanup on unmount
    }, [resendCtr]);

    function handleClick() {
        // Logic to resend the email
        console.log("Resend email clicked");


        if (timer == 0) {
            // Reset timer
            setTimer(120);
            const ctrNextTimer = resendCtr + 1;
            setResendCtr(ctrNextTimer)

            fetch(`${process.env.REACT_APP_BACKEND_URL}/api/v1/resend/`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': process.env.REACT_APP_KIZABO_API_KEY },
                body: JSON.stringify({
                    id: props.userId,
                })
            }).then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json(); // parse JSON body
            }).then(data => {
                console.log("Email was sent successfully", data);
            });
        }

    }

    const resendMessage = (timer !== 0) ? `Resend in (${timer}) seconds` : "Resend email"

    return (
        <form className="Form" >
            <div className="Form--inputs-container">
                <h4 className="Form--instructions">The results have been sent to your email <span className="Form--instructions-bold">{props.email}</span>. Check your inbox and your spam folder. Haven’t received the results? <a className="Form--instructions-clickable" onClick={handleClick}>{resendMessage}</a>.

                    How was the experience? Reach out to us via <a className="Form--instructions-clickable" href={`mailto:${email}`}>{email}</a></h4>
            </div>
        </form>
    )
}